/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Settings_Casmanagement_Table_Lpportalvisibility3Inputs */

const en_settings_casmanagement_table_lpportalvisibility3 = /** @type {(inputs: Settings_Casmanagement_Table_Lpportalvisibility3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`LP Portal Visibility`)
};

/**
* | output |
* | --- |
* | "LP Portal Visibility" |
*
* @param {Settings_Casmanagement_Table_Lpportalvisibility3Inputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const settings_casmanagement_table_lpportalvisibility3 = /** @type {((inputs?: Settings_Casmanagement_Table_Lpportalvisibility3Inputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Settings_Casmanagement_Table_Lpportalvisibility3Inputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_settings_casmanagement_table_lpportalvisibility3(inputs)
});
export { settings_casmanagement_table_lpportalvisibility3 as "settings_casManagement_table_lpPortalVisibility" }